<template>
  <div id="hit-cells-small" v-bind:style="{'background-color': survey.badge.bg}">

    <div class="hit-title" v-bind:style="{color: survey.badge.text}">{{ survey.name }}</div>

    <div class="hit-proz-container">
      <div class="hit-proz-count" v-bind:style="{'background-color': survey.badge.accent, color: survey.badge.pluscolor}">{{ survey.all }}</div>
      <div class="hit-proz-stars" v-bind:style="{'background-color': survey.badge.pluscolor}">
        <hit_stars :stars="survey.all_percent" v-bind:style="{'color': survey.badge.accent}" />
      </div>

    </div>

    <div class="hit-top-stars" v-if="survey.all" v-bind:style="{'color': survey.badge.accent}">{{ survey.all_percent }} von 5 Sternen</div>
    <div class="hit-top-stars" v-if="!survey.all" v-bind:style="{color: survey.badge.text}">{{ $tc("message.noEntry", survey.all) }}</div>

    <div class="hit-validated" v-if="survey.all" v-bind:style="{color: survey.badge.text}">{{ $t("message.validation") }}: 100%</div>

    <div class="hit-banderole-container"><a class="hit-banderole hit-html-a" href="https://hitklick.com" target="_blank" v-bind:style="{'color': survey.badge.pluscolor, 'background-color': survey.badge.accent}"><b>hitklick</b>.com</a></div>
  </div>
</template>

<script>

export default{

  name: 'cells_small',
  props: { global: Object, survey: Object, avg: Object, stars: Array },

  computed: {

    stars_reverse: function () {
      var rev = JSON.parse(JSON.stringify(this.stars))

      return rev.reverse()
    },

    sort_votes: function () {
      var votes = this.survey.votes

      var sortable = []

      for (var vote in votes) {
        sortable.push([vote, votes[vote]])
      }

      sortable.sort(function (a, b) {
        return a[1] - b[1]
      })

      sortable = sortable.reverse()

      return sortable
    }

  },
  methods: {

    get_width: function (star) {
      if (!this.survey.percent[star]) { return {} }

      const width = (this.survey.percent[star] / 100) * 150

      return {width: width + 'px'}
    },

    get_avg_star_class: function (key) {
      if (Number.isInteger(this.survey.all_percent) == false && (key - this.survey.all_percent) < 1 && key > this.survey.all_percent) { return {'hit-glyphicon-star-half': true} } else if (key <= this.survey.all_percent) { return {'hit-glyphicon-star': true} } else { return {'hit-glyphicon-star-empty': true} }
    },
    get_avg_star_class2: function (index, key) {
      if (key >= index) { return {'hit-glyphicon-star': true} } else { return {'hit-glyphicon-star-empty': true} }
    }
  }

}

</script>

<style scoped>

#hit-cells-small{
  text-align: center;
  width: 250px;

  font-family: Arial;
  font-size: 12pt;
  overflow: hidden;
  display: inline-block;
  background-color: lightgrey;

}

#hit-cells-small .hit-banderole-container{
  text-align: left;

}

#hit-cells-small .hit-banderole{
  display: block;
  font-size: 8pt;
  background-color: #717c80;
  padding: 4px 10px;
  color: white;
  margin-top: 10px;
  text-align: right;

}

#hit-cells-small .hit-title{
  margin-top: 20px;
  margin-bottom: 10px;
  padding: 0 40px;
  font-size: 12px;
  line-height: 0.9em;
}

#hit-cells-small .hit-top-stars{
  font-size: 16pt;
  font-weight: bold;
  margin-top: 10px;
}

#hit-cells-small .hit-stars{
  margin-bottom: 20px;
  font-size: 18pt;
}

#hit-cells-small .hit-proz-count{
  display: block;
  width: 60px;
  background-color: #717c80;

  font-size: 17px;

  height: 40px;
  padding-top: 7px;
  border-top-left-radius: 8px;
  border-bottom-left-radius: 8px;
  color: white;
  float:left;
  box-shadow: 0px 5px 10px -5px rgba(0,0,0,0.5);
}

#hit-cells-small .hit-proz-stars{
  display: block;
  background-color: white;
  padding: 8px;
  font-size: 20px;
  line-height: 1em;
  height: 40px;
  width: 200px;
  box-sizing: border-box;
  border-radius: 8px;
  margin-left: -3px;
  margin:0;
  box-shadow: 0px 5px 10px -5px rgba(0,0,0,0.5);
}

#hit-cells-small .hit-votes{
  margin-top: 10px;
}

#hit-cells-small .hit-validated{
  font-size: 10px;
  margin-top: 10px;
}

#hit-cells-small .hit-proz-container{
  margin: 0;
  text-align: center;
  display: inline-block;
}
</style>
